import { useState } from "react";
import { colors, typography, radii } from "../../../styles/tokens";

const SEV = {
  critical: { color: "#c0392b", label: "CRITIQUE" },
  high:     { color: "#e67e22", label: "ÉLEVÉ" },
  medium:   { color: "#f39c12", label: "MOYEN" },
  low:      { color: "#27ae60", label: "FAIBLE" },
};

export function VulnerabilityCardBlock({ block, accentColor }) {
  const d = block.data || {};
  const sev = SEV[d.severity] || SEV.medium;
  const [expanded, setExpanded] = useState(false);
  const accent = accentColor || colors.accentBright;

  return (
    <div style={{
      fontFamily: typography.fontFamily.body,
      border: `1px solid ${colors.border}`,
      borderLeft: `4px solid ${sev.color}`,
      borderRadius: radii.lg,
      overflow: "hidden",
      margin: "8px 0",
    }}>
      {/* Header */}
      <div style={{
        display: "flex", alignItems: "center", gap: 10,
        padding: "12px 16px",
        background: `${sev.color}08`,
        cursor: "pointer",
      }} onClick={() => setExpanded(!expanded)}>
        <span style={{
          fontSize: 9, fontWeight: 700, letterSpacing: "0.06em",
          padding: "3px 8px", borderRadius: 4,
          background: sev.color, color: "#fff",
          textTransform: "uppercase",
        }}>{sev.label}</span>
        {d.cvss != null && (
          <span style={{
            fontSize: 11, fontWeight: 700, color: sev.color,
            fontFamily: typography.fontFamily.body,
          }}>CVSS {d.cvss}</span>
        )}
        <span style={{
          fontSize: 14, fontWeight: 600, color: colors.text.primary, flex: 1,
          fontFamily: typography.fontFamily.heading,
        }}>{d.title || "Vulnerability"}</span>
        <span style={{ fontSize: 10, color: colors.text.muted }}>
          {expanded ? "▲" : "▼"}
        </span>
      </div>

      {/* Body */}
      {expanded && (
        <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: 10 }}>
          {d.vector && (
            <div style={{
              fontSize: 10, fontFamily: typography.fontFamily.body,
              color: colors.text.muted, background: colors.bg,
              padding: "4px 8px", borderRadius: 4, width: "fit-content",
              letterSpacing: "0.03em",
            }}>{d.vector}</div>
          )}

          {d.description && (
            <div>
              <div style={{ fontSize: 10, fontWeight: 600, color: colors.text.muted, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.05em" }}>Description</div>
              <div style={{ fontSize: 13, lineHeight: 1.6, color: colors.text.primary }}>{d.description}</div>
            </div>
          )}

          {d.remediation && (
            <div>
              <div style={{ fontSize: 10, fontWeight: 600, color: colors.text.muted, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.05em" }}>Remédiation</div>
              <div style={{ fontSize: 13, lineHeight: 1.6, color: colors.text.primary }}>{d.remediation}</div>
            </div>
          )}

          {d.references?.length > 0 && (
            <div>
              <div style={{ fontSize: 10, fontWeight: 600, color: colors.text.muted, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.05em" }}>Références</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {d.references.map((ref, i) => (
                  <span key={i} style={{
                    fontSize: 11, color: accent, cursor: "default",
                    background: `${accent}10`, padding: "2px 8px",
                    borderRadius: 4, border: `1px solid ${accent}30`,
                  }}>{ref.title || ref.url}</span>
                ))}
              </div>
            </div>
          )}

          {d.tags?.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 4 }}>
              {d.tags.map((tag, i) => (
                <span key={i} style={{
                  fontSize: 10, padding: "2px 6px", borderRadius: 3,
                  background: colors.bg, border: `1px solid ${colors.border}`,
                  color: colors.text.muted, fontFamily: typography.fontFamily.body,
                }}>{tag}</span>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
